<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Normaal tarief vennootschapsbelasting
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <div id="bldSubContent1"><p>De tarieven voor de vennootschapsbelasting in 2024 zijn:</p>

                    <table>
                        <thead>
                        <tr>
                            <th>
                                <p>Voor het deel van het belastbare bedrag</p>
                            </th>
                            <th>
                                <p>Tarief</p>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="col-1">
                                <p>tot en met €&nbsp;200.000</p>
                            </td>
                            <td class="col-2">
                                <p>19,0%</p>
                            </td>
                        </tr>

                        <tr>
                            <td class="col-1">
                                <p>boven €&nbsp;200.000</p>
                            </td>
                            <td class="col-2">
                                <p>25,8%</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="heading2">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                    Aftrek elders belast
                </button>
            </h2>
            <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
                 data-bs-parent="#accordionExample">
                <div class="accordion-body">

                    <p>Als de vennootschap winst heeft uit een buitenlandse onderneming of inkomsten uit buitenlandse
                        onroerende zaken, dan is de objectvrijstelling van toepassing.</p>
                    <p>In 3 situaties is de objectvrijstelling niet van toepassing:</p>
                    <ul>
                        <li>De overgangsregeling vrijstelling wegens doorgeschoven buitenlandse winsten en in te halen
                            verliezen is van toepassing (de vrijstellingsmethode).
                        </li>
                        <li>De vennootschap heeft een buitenlands inkomen waarop bronbelasting is ingehouden (de
                            verrekeningsmethode).
                        </li>
                        <li>De vennootschap heeft een laagbelaste buitenlandse beleggingsonderneming.<br>
                            De objectvrijstelling geldt wel als op basis van een verdrag ter voorkoming van dubbele
                            belasting de vrijstellingsmethode van toepassing is op winst uit een laagbelaste
                            buitenlandse beleggingsonderneming.
                        </li>
                    </ul>
                    <b>Overgangsregeling vrij te stellen buitenlandse winsten en verliezen</b>
                    <p>Als de vennootschap uit jaren voor 2012 nog door te schuiven winsten heeft, dan vallen deze niet
                        onder de
                        objectvrijsteling. Op deze winsten blijft de vrijstellingsmethode van toepassing.</p>
                    <p>Als de vennootschap uit jaren voor 2012 nog in te halen verliezen uit een land hebt, dan is de
                        objectvrijstelling pas van toepassing als de winst uit dat land hoger is dan de in te halen
                        verliezen.</p>
                    <b>Verrekening van buitenlandse bronbelasting</b>
                    <p>Als de vennootschap winstbestanddelen heeft waarop bronbelasting is ingehouden, dan geldt
                        hiervoor de
                        verrekeningsmethode. De verrekeningsmethode geldt voor een aantal specifieke winstbestanddelen
                        waaronder dividenden, interest en royalty's. Sommige belastingverdragen schrijven de
                        verrekeningsmethode ook voor andere winstbestanddelen dan dividenden, interest en royalty's
                        voor.</p>
                    <p>Naast de bij de verrekeningsmethode genoemde limieten, kan het bedrag van de te verrekenen
                        buitenlandse bronbelasting nooit hoger zijn dan de Nederlandse belasting.</p>

                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="heading3">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                    Te verrekenen dividendbelasting
                </button>
            </h2>
            <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
                 data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    Het gaat om dividendbelasting die in het boekjaar is ingehouden op ontvangen dividenden die deel
                    uitmaken van de belastbare winst. Je vindt de dividendbelasting die is ingehouden, meestal op de
                    dividendnota's. Geef alleen Nederlandse dividendbelasting aan.
                    <br/> <br/>
                    <p>
                        Let op! Vanaf 2022 kun je dividendbelasting en kansspelbelasting alleen nog verrekenen met de
                        vennootschapsbelasting die de vennootschap betaalt. Is er in een jaar geen
                        vennootschapsbelasting
                        verschuldigd, dan krijgt je geen teruggaaf van voorheffingen.
                        <br/><br/>
                        De niet-verrekende voorheffingen kun je onbeperkt doorschuiven naar latere jaren. Je kunt dan de
                        voorheffingen in een later jaar verrekenen met de te betalen vennootschapsbelasting.
                    </p>

                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header" id="heading4">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                    Te verrekenen kansspelbelasting
                </button>
            </h2>
            <div id="collapse4" class="accordion-collapse collapse" aria-labelledby="heading4"
                 data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    Het gaat om Nederlandse kansspelbelasting die in dit boekjaar is ingehouden op kansspelinkomsten die
                    deel uitmaken van de belastbare winst.
                    <br/> <br/>
                    <p>
                        Let op! Vanaf 2022 kun je dividendbelasting en kansspelbelasting alleen nog verrekenen met de
                        vennootschapsbelasting die de vennootschap betaalt. Is er in een jaar geen
                        vennootschapsbelasting verschuldigd, dan krijgt je geen teruggaaf van voorheffingen.
                        <br/><br/>
                        De niet-verrekende voorheffingen kun je onbeperkt doorschuiven naar latere jaren. Je kunt dan de
                        voorheffingen in een later jaar verrekenen met de te betalen vennootschapsbelasting.
                    </p>
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <div *ngIf="dataService.isDefAangifte.value">
                <h2 class="accordion-header" id="heading5">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                        Te verrekenen voorlopige aanslagen
                    </button>
                </h2>
                <div id="collapse5" class="accordion-collapse collapse" aria-labelledby="heading5"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Vul het totale bedrag in van de voorlopige aanslagen vennootschapsbelasting in dit boekjaar.
                        <br/><br/>
                        <b>Let op! Is er per saldo sprake van een teruggave op voorlopige aanslagen, zet dan een
                            minteken voor het bedrag.</b>
                        <br/><br/>
                        Het bedrag dat je hier vermeldt, heeft alleen invloed op de hier getoonde berekening in het
                        overzicht van het
                        te betalen of te ontvangen belastingbedrag. De Belastingdienst gebruikt de berekening niet voor
                        het
                        vaststellen van de definitieve aanslag. De Belastingdienst verrekent alle opgelegde voorlopige
                        aanslagen, ook als je deze niet vermeldt.
                    </div>
                </div>
            </div>
            <div *ngIf="!dataService.isDefAangifte.value">
                <h2 class="accordion-header" id="heading6">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                        Te verrekenen voorlopige aanslagen
                    </button>
                </h2>
                <div id="collapse6" class="accordion-collapse collapse" aria-labelledby="heading6"
                     data-bs-parent="#accordionExample">
                    <div class="accordion-body">
                        Vul het totale bedrag in van de voorlopige aanslagen vennootschapsbelasting in dit boekjaar.
                        Daarbij gaat het om de opgelegde aanslagen.
                        <br/><br/>
                        <b>Let op! Is er per saldo sprake van een teruggave op voorlopige aanslagen, zet dan een
                            minteken voor het bedrag.</b>
                        <br/><br/>
                        Het bedrag dat je hier vermeldt, heeft alleen invloed op de hier getoonde berekening in het
                        overzicht van het te betalen of te ontvangen belastingbedrag. De Belastingdienst gebruikt de
                        berekening niet voor
                        het vaststellen van de definitieve aanslag. De Belastingdienst verrekent alle opgelegde
                        voorlopige
                        aanslagen, ook als je deze niet vermeldt.
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>
